export default __webpack_public_path__ + "ddd6420573dd13063b129034942fa08b.png";